import React, { createContext, useState, useEffect } from 'react';
import axios from "axios";
import api, {consoleDevLog} from "../apiConfig";

const ContactsContext = createContext();

const ContactsProvider = (props) => {

    const [contacts, setContacts] = useState([]);

    useEffect(() => {
        api.get('/clients')
            .then(response => {
                // Print the keys in each value of response.data
                response.data.forEach((contact) => {
                    consoleDevLog(Object.keys(contact));
                })
                setContacts(response.data);
            })
            .catch(error => {
                console.error('There was an error fetching the data: ', error);
            });
    }, [window.localStorage]); // The empty dependency array ensures the API call is made only once, when the component mounts

    const addContact = (newContact) => {
        setContacts(prevContacts => [...prevContacts, newContact]);
    };

    const removeContact = (indexToRemove) => {
        const updatedContacts = contacts.filter((_, index) => index !== indexToRemove);
        setContacts(updatedContacts);
    };

    const updateClientResources = (clientName, newResourceLink) => {
        setContacts((prevContacts) => {
            return prevContacts.map((contact) => {
                if (contact.firstName + " " + contact.lastName === clientName) {
                    consoleDevLog("Updating resources for:", contact.firstName);
                    return {
                        ...contact,
                        clientResources: newResourceLink,
                    };
                } else {
                    return contact;
                }
            });
        });
    };

    return (
        <ContactsContext.Provider value={{ contacts, addContact, removeContact, updateClientResources }}>
            {props.children}
        </ContactsContext.Provider>
    );
};

export { ContactsContext, ContactsProvider };
